module.exports = __webpack_public_path__ + "static/media/giovanni-intro-2.3a00e9f4.wav";